export const FIELD_TO_COLUMN_TITLE_KEY: Record<string, string> = {
  notificationsEnabled: 'alertsManagerWidget:alertRules.columnTitle.notifications',
  journalEnabled: 'alertsManagerWidget:alertRules.columnTitle.saveToNotificationLog',
  context: 'alertsManagerWidget:alertRules.columnTitle.context',
  riskLevel: 'alertsManagerWidget:alertRules.columnTitle.riskLevel',
  author: 'alertsManagerWidget:alertRules.columnTitle.author',
  anomalyTypeId: 'alertsManagerWidget:alertRules.columnTitle.type',
  anomalySubtypeId: 'alertsManagerWidget:alertRules.columnTitle.subtype',
  sourceType: 'alertsManagerWidget:alertRules.columnTitle.type',
  sourceOption: 'alertsManagerWidget:alertRules.columnTitle.name',
  holeDepthFrom: 'alertsManagerWidget:alertRules.columnTitle.from',
  holeDepthTo: 'alertsManagerWidget:alertRules.columnTitle.to',
  depthFrom: 'alertsManagerWidget:alertRules.columnTitle.from',
  depthTo: 'alertsManagerWidget:alertRules.columnTitle.to',
  unitId: 'alertsManagerWidget:alertRules.columnTitle.unit',
  minValue: 'alertsManagerWidget:alertRules.columnTitle.min',
  minReference: 'alertsManagerWidget:alertRules.columnTitle.parameter',
  minPercent: '%',
  maxValue: 'alertsManagerWidget:alertRules.columnTitle.max',
  maxReference: 'alertsManagerWidget:alertRules.columnTitle.parameter',
  maxPercent: '%',
  diffInterval: 'alertsManagerWidget:alertRules.columnTitle.diffInterval',
  diffValue: 'alertsManagerWidget:alertRules.columnTitle.diffValue',
} as const;
